import { TipoArquivo } from '../../models/tipo-arquivo.enum';
import { CategoriaArquivo } from '../../models/categoria-arquivo.enum';

export class ArquivoVisualizavel {

  constructor(public nome: string, public tipo: TipoArquivo, public categoria: CategoriaArquivo, public conteudo: Blob) {}

  public getContentType(): string {
    if (TipoArquivo.NAO_IDENTIFICADO === this.tipo) {
      return 'application/octet-stream';
    }
    else {
      return this.tipo.replace('_', '/').toLowerCase();
    }
  }
}
